import { Injectable } from '@angular/core';
import { Http } from "@angular/http";
import { TranslateService } from 'ng2-translate';


@Injectable()
export class ProductosService {
  productos:any[] = [];
  cargando:boolean = false;
  constructor( private http:Http, private translate:TranslateService ) {
    this.cargar_productos();
  }

  public cargar_productos () {
    this.cargando = true;
    this.http.get('https://paginaweb-41864.firebaseio.com/productos_idx.json')
      .subscribe(res => {
        console.log(res.json());
        this.productos = res.json();
      })
  }
}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/services/productos.service.ts